import * as React from 'react';
import { SVGProps } from 'react';

const WarningIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 41 41"
    {...props}
    fill="currentColor"
  >
    <path d="M28.6997 0.708374L40.2913 12.3063V28.7021L28.6997 40.2917H12.3038L0.708008 28.7V12.3042L12.3038 0.708374H28.6997ZM26.9726 4.87504H14.0288L4.87676 14.0313V26.975L14.0288 36.1292H26.9726L36.1268 26.975V14.0292L26.9726 4.87712V4.87504ZM18.4163 26.75H22.583V30.9167H18.4163V26.75ZM18.4163 10.0834H22.583V22.5834H18.4163V10.0834Z" />
  </svg>
);

export default WarningIcon;
